module.exports = __webpack_public_path__ + "static/media/logo_makaw_dev.7a38c506.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/logo_makaw_dev.svg
// module id = 2280
// module chunks = 0